module.exports = __webpack_public_path__ + "static/media/130.0bdd8b09.png";